<template>
  <BaseIndex
    ref="baseIndex"
    modelNameSingular="modelNameSingular"
    :modelNamePlural="modelNamePlural"
    :pageLoading="pageLoading"
    :loading="loading"
    :table-headers="computedHeaders"
    :table-items="exitMovementItems"
    :indexNested="true"
    :disablePagination="true"
    :maskFields="maskFields"
    :hasTableTitle="true"
  >
    <template slot="new" v-if="!readOnly">
      <New
        @entry-created="entryCreated"
        :executionOperation="executionOperation"
        :seedPlotOperation="seedPlotOperation"
        :serviceProvision="serviceProvision"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="show" slot-scope="{ item }">
      <Edit
        :entry="item"
        :readOnly="true"
        :executionOperation="executionOperation"
        :seedPlotOperation="seedPlotOperation"
        :serviceProvision="serviceProvision"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="edit" v-if="!readOnly" slot-scope="{ item }">
      <Edit
        :entry="item"
        @entry-updated="entryUpdated"
        :executionOperation="executionOperation"
        :seedPlotOperation="seedPlotOperation"
        :serviceProvision="serviceProvision"
        :isEdit="isEdit"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="delete" v-if="!readOnly" slot-scope="{ item }">
      <Delete
        :entry="item"
        @entry-destroyed="entryDeleted"
        :modelNameSingular="modelNameSingular"
      />
    </template>
    
    <template slot="action1" v-if="planningOperation" slot-scope="{ item }">
      <v-tooltip top color="orange" v-if="item.hasItemInStorage === false">
        <template v-slot:activator="{ on: tooltip }">
          <v-icon
            v-on="{ ...tooltip }"
            class="mx-1"
            color="orange"
          >
            mdi-alert-remove
          </v-icon>
        </template>
        <span>Este ítem não se encontra em estoque!</span>
      </v-tooltip>
    </template>

  </BaseIndex>
</template>

<script>
import BaseIndex from "@shared_components/base_index.vue";
import New from "./new.vue";
import Edit from "./edit.vue";
import Delete from "./delete.vue";

export default {
  data() {
    return {
      loading: false,
      pageLoading: false,
      indexKey: 1,
      maskFields: [
        // { field: 'price', mask: 'currency_10d' },
        { field: 'quantity', mask: 'number' },
        // { field: 'totalPrice', mask: 'currency'}
      ]
    };
  },
  components: {
    BaseIndex: BaseIndex,
    New: New,
    Edit: Edit,
    Delete: Delete,
  },
  props: {
    exitMovementItems: { 
      type: Array,
      default: () => []
    },
    executionOperation: Object,
    seedPlotOperation: Object,
    serviceProvision: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: { // utilizado para definir se o form é de edição
      type: Boolean,
      default: false
    },
    planningOperation: {
      default: null,
      type: Object
    },
    modelNameSingular: {
      type: String,
      default: "Item Consumido"
    },
    modelNamePlural: {
      type: String,
      default: "Itens Consumidos"
    },
  },
  created() {
  },
  computed: {
    computedHeaders () {
      return [
        // ... this.planningOperation ? [{ text: "Disponível", value: "link1", sortable: false }] : [],
        { text: "Item", align: "left", sortable: true, value: "item.name" },
        { text: "Embalagem", align: "left", sortable: true, value: "packaging.name" },
        { text: "Estoque", align: "left", sortable: true, value: "storage.name" },
        { text: "Quantidade", align: "left", sortable: true, value: "quantity" },
        { text: "Unidade", align: "left", sortable: true, value: "item.unit.name" },
        // { text: "Und.", align: "left", sortable: true, value: "item.unit.name" },
        // { text: "R$ Total", align: "left", sortable: true, value: "totalPrice" },
        // { text: "deleted", value: "_destroy", align: ' d-none', sortable: false, filter: value => value ? !value : true },
        { text: "Ações", value: "action", sortable: false }
      ]
    }
  },
  methods: {
    entryUpdated: function(editedEntry){
      this.$refs.baseIndex.showConfirmationUpdateMessage();
    },
    entryCreated: function(editedEntry){
      this.exitMovementItems.push(editedEntry);
      this.$refs.baseIndex.showConfirmationCreateMessage();
    },
    entryDeleted: function(editedEntry){
      this.$refs.baseIndex.showConfirmationDeleteMessage();
    },
  }
};
</script>

<style scoped></style>
